<template>
  <div class="d-flex g-4 align-items-center justify-content-between flex-md-wrap flex-lg-nowrap">
    <div v-if="establishments" class="w-100 d-flex align-items-center">
      <a href="#" class="arrow-establishment">
        <i class="d-inline-block text-primary icon-20 bi-chevron-left pe-1"
           @click.prevent="$emit('previousEstablishment')"></i>
      </a>
      <div class="flex-grow-1 flex-shrink-1 w-0">
        <DropDownSearch
            :items="establishments"
            :currentValue="establishment"
            :showSearchField="true"
            defaultLabel="Etab."
            @dropdownClick="$emit('update:establishment', $event)"
        />
      </div>
      <a href="#" class="arrow-establishment">
        <i class="d-inline-block text-primary icon-20 bi-chevron-right ps-1"
           @click.prevent="$emit('nextEstablishment')"></i>
      </a>
    </div>

    <div class="w-100">
      <DropDownSearch
          class="sw-20"
          :items="sentiments"
          :currentValue="sentiment"
          :showSearchField="false"
          defaultLabel="Sentiment"
          @dropdownClick="$emit('update:sentiment', $event)"
      />
    </div>

    <div v-if="platforms" class="w-100">
      <DropDownSearch
          class="sw-20"
          :items="platforms"
          :currentValue="platform"
          :showSearchField="true"
          defaultLabel="Plateforme"
          @dropdownClick="$emit('update:platform', $event)"
      />
    </div>

    <div class="w-100">
      <DropDownSearch
          class="sw-20"
          :items="status_set"
          :currentValue="status"
          :showSearchField="false"
          defaultLabel="Statut"
          @dropdownClick="$emit('update:status', $event)"
      />
    </div>

    <div class="w-100">
      <DropDownSearch
          class="sw-20"
          :items="tag_set"
          :currentValue="tag"
          :showSearchField="false"
          defaultLabel="Tag"
          @dropdownClick="$emit('update:tag', $event)"
      />
    </div>

    <div class="w-100 mx-4">
      <DateInput
          :modelValue="dateBegin"
          label="Date début"
          format="DD/MM/YYYY"
          @change="$emit('update:dateBegin', $event)"
      />
    </div>

    <div class="w-100 mx-4">
      <DateInput
          :modelValue="dateEnd"
          label="Date fin"
          format="DD/MM/YYYY"
          @change="$emit('update:dateEnd', $event)"
      />
    </div>

    <div v-if="showConsultant && Array.isArray(consultants)" class="w-100">
      <DropDownSearch
          class="sw-20"
          :items="consultants"
          :currentValue="consultant"
          :showSearchField="false"
          defaultLabel="Consultant"
          shownKey="fullname"
          @dropdownClick="$emit('update:consultant', $event)"
      />
    </div>

    <div v-if="showConsultant" class="w-100">
      <UiSwitch
          :modelValue="classified"
          label="Classé"
          @change="$emit('update:classified', $event)"
      />
    </div>

    <div class="w-100 d-flex gap-2 align-items-center" v-if="padAndLogos">
      <button type="button"
              @click="$emit('toggle-pad')"
              class="btn btn-sm btn-primary">
        <span>
          <i :class="[showPad ? 'bi-eye-slash' : 'bi-eye', 'icon-14 me-2']"></i>
          {{ showPad ? 'Masquer' : 'Afficher' }} le pad
        </span>
      </button>
      <button type="button"
              @click="$emit('toggle-logos')"
              class="btn btn-sm btn-primary">
        <span>
          <i :class="[showLogos ? 'bi-eye-slash' : 'bi-eye', 'icon-14 me-2']"></i>
          {{ showLogos ? 'Masquer' : 'Assistant' }} IA
        </span>
      </button>
    </div>

    <div class="w-100 d-flex align-items-center mx-auto">
      <a href="#" class="position-relative d-inline-flex" data-bs-toggle="modal" data-bs-target="#stat-modal-consult">
        <PourcentageStatTag :pourcentage="pourcentageStatTagValue"/>
      </a>
    </div>
  </div>
</template>


<script>
import DropDownSearch from '@/components/ui/DropDownSearch.vue';
import DateInput from '@/components/ui/DateInput.vue';
import UiSwitch from '@/components/ui/Switch.vue';
import PourcentageStatTag from '@/components/PourcentageStatTag.vue';

export default {
  name: 'FilterBar',
  components: { DropDownSearch, DateInput, UiSwitch, PourcentageStatTag },
  props: {
    establishments: Array,
    establishment: Object,
    sentiments: Array,
    sentiment: Object,
    platforms: {
      type: [Array, null],
      default: () => []
    },
    platform: Object,
    status_set: Array,
    status: Object,
    tag_set: Array,
    tag: Object,
    dateBegin: [String, Date, null],
    dateEnd: [String, Date, null],
    consultants: {
      type: [Array, null],
      default: () => []
    },
    consultant: Object,
    classified: Boolean,
    pourcentageStatTagValue: Number,
    showPad: Boolean,
    showLogos: Boolean,
    padAndLogos: Boolean,
    showConsultant: Boolean
  }
};
</script>

<style scoped>
.icon-20 {
  font-size: 20px;
}
</style>
